import React from "react";

const Testimonials = () => {
  return (
    <div>
      <section id="testimonials" class="testimonials section">
        <div class="container">
          <div class="container section-title" data-aos="fade-up">
            <h2>Testimonials</h2>
            <p>What people say About Us</p>
          </div>

          <div class="row gy-4">
            <div class="col-lg-12" data-aos="fade-up" data-aos-delay="300">
              <div class="testimonial-item">
                <h3>Archana Mehta</h3>
                <h4>- Real Estate Investor</h4>
                <div class="stars">
                  <i class="bi bi-star-fill"></i>
                  <i class="bi bi-star-fill"></i>
                  <i class="bi bi-star-fill"></i>
                  <i class="bi bi-star-fill"></i>
                  <i class="bi bi-star-fill"></i>
                </div>
                <p>
                  <i class="bi bi-quote quote-icon-left"></i>
                  <span>
                    Visko Group's commitment to innovation is evident in their
                    projects. The real estate solutions Fraction Realty offers
                    have made property investment accessible to a wider
                    audience. Their dedication to transforming industries is
                    truly inspiring.
                  </span>
                  <i class="bi bi-quote quote-icon-right"></i>
                </p>
              </div>
            </div>

            <div class="col-lg-6" data-aos="fade-up" data-aos-delay="100">
              <div class="testimonial-item">
                <h3>Diksha Agrawal</h3>
                <h4>HR Manager</h4>
                <div class="stars">
                  <i class="bi bi-star-fill"></i>
                  <i class="bi bi-star-fill"></i>
                  <i class="bi bi-star-fill"></i>
                  <i class="bi bi-star-fill"></i>
                  <i class="bi bi-star-fill"></i>
                </div>
                <p>
                  <i class="bi bi-quote quote-icon-left"></i>
                  <span>
                    Remark has been a game-changer for our recruitment process.
                    The precision with which it matches candidates to our
                    company culture and requirements is remarkable. It's not
                    just a tool; it's a partner in building our dream team.
                  </span>
                  <i class="bi bi-quote quote-icon-right"></i>
                </p>
              </div>
            </div>

            <div class="col-lg-6" data-aos="fade-up" data-aos-delay="200">
              <div class="testimonial-item">
                <h3>Rakesh Sharma </h3>
                <h4> Freelance Consultant</h4>
                <div class="stars">
                  <i class="bi bi-star-fill"></i>
                  <i class="bi bi-star-fill"></i>
                  <i class="bi bi-star-fill"></i>
                  <i class="bi bi-star-fill"></i>
                  <i class="bi bi-star-fill"></i>
                </div>
                <p>
                  <i class="bi bi-quote quote-icon-left"></i>
                  <span>
                    I can't imagine managing my communication without Humming
                    Bird. It's like having a personal assistant for staying
                    organized. Scheduling messages ahead of time has transformed
                    the way I engage with clients and colleagues.
                  </span>
                  <i class="bi bi-quote quote-icon-right"></i>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Testimonials;
